module.exports = __webpack_public_path__ + "static/media/homezhexian.eccf2e29.png";